import styled from 'styled-components'

export const Section = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  padding-top: 0;
  background-color: #f0f0f0;
`

export const SectionBox = styled.div`
  background-color: white;
  border-radius: 2rem;
  padding: 2rem;
  width: 100%;
  max-width: 1000px;
  aspect-ratio: 1 / 1;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    aspect-ratio: auto;
    padding: 1rem;
  }
`

export const AboutBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'text1 image1'
    'image2 text2';
  gap: 1rem;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'text1'
      'image1'
      'text2'
      'image2';
  }
`

export const TextBoxTop = styled.div`
  grid-area: text1;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  flex-direction: column;

  color: rgb(107, 107, 107);
  font-size: 1rem;
  line-height: 1.6;
  text-align: justify;
`

export const TextBoxBottom = styled.div`
  grid-area: text2;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  flex-direction: column;

  color: rgb(107, 107, 107);
  font-size: 1rem;
  line-height: 1.6;
  text-align: justify;
`

export const ImageBoxTop = styled.div`
  grid-area: image1;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`

export const ImageBoxBottom = styled.div`
  grid-area: image2;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`

export const Heading = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  text-align: center;
`

export const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 1rem;
  display: block;
`
